import React from "react";
import "./news.style.sass";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button } from "rsuite";
import SingleNews from "../../pages/singleNews/singleNews.page";
import { withRouter, Route, Link } from "react-router-dom";
import SingleNewsLayout from "../../layouts/singleNews/singleNews.layout";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { selectApplication, selectNews } from "../../redux/site/site.selector";
import { Setting } from "../../setting";

class NewsComponent extends React.Component {
	render() {
		const { news, history, application, newsData } = this.props;
		console.log(application);
		const settings = {
			dots: true,
			infinite: true,
			speed: 1000,
			slidesToShow: 5,
			slidesToScroll: 1,
			autoplay: true,
			rtl: true,
			responsive: [
				{
					breakpoint: 1730,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
					},
				},
				{
					breakpoint: 1370,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
					},
				},
				{
					breakpoint: 1022,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
					},
				},
				{
					breakpoint: 685,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		};

		return (
			<div className={`news-main ${news ? null : "usage-main"}`}>
				<Route
					path={`${history.pathname}/:id`}
					component={SingleNews}
				/>
				<div className="news-content">
					<h3 style={news ? { marginBottom: 0 } : { color: "white" }}>
						{news ? "اخبار" : "کاربرد های"} <span>زیتونیکس</span>
					</h3>
					{news ? (
						<div className="news-archive-button">
							<Link to="/news">
								<Button>آرشیو اخبار</Button>
							</Link>
						</div>
					) : null}
					<Slider {...settings}>
						{!news && application
							? application.map((item, i) => (
									<div
										key={i}
										className="news-items"
									>
										<img
											src={`${Setting.apiUrl}/${item.img}`}
											alt="xitonix-news"
										/>
										<div className="usage-bottom-title">
											<p>{item.name}</p>
										</div>
									</div>
							  ))
							: null}
						{newsData && news
							? newsData.map((item, i) => (
									<div key={i}>
										<div className="news-items">
											<img
												src={`${Setting.apiUrl}/${item.gallery[0].path}`}
												alt="xitonix-news"
											/>
										</div>
										<div className="news-item-texts">
											<h5>{item.title}</h5>
											<div className="news-button">
												<Link to={`/news/${item.id}`}>
													<Button>جزییات خبر</Button>
												</Link>
											</div>
										</div>
									</div>
							  ))
							: null}
					</Slider>
				</div>
			</div>
		);
	}
}
const mapStateToProps = createStructuredSelector({
	application: selectApplication,
	newsData: selectNews,
});

export default withRouter(connect(mapStateToProps)(NewsComponent));
